// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-menu__content>>>.v-list-item__title{max-width:445px!important}", ""]);
// Exports
module.exports = exports;
